import instance from 'api/instance';
import { IGetTimeslotsBranch, IGetTimeslotsBranchById } from './types';
import qs from 'query-string';

export const getTimeslotsBranches: IGetTimeslotsBranch = (params) =>
  instance.get(`/timeslots-branches?${qs.stringify(params)}`);

export const getTimeslotsBranchById: IGetTimeslotsBranchById = (id) =>
  instance.get(`/timeslots-branches/${id}`);
